import './CompareWorkshops.css';
import CompareWorkshopsRow from './CompareWorkshopsRow';
import CompareWorkshopsRowImage from './CompareWorkshopsRowImage';
import CompareWorkshopsPublicationAnalysisRow from './CompareWorkshopsPublicationAnalysisRow';

const CompareWorkshopsActivity2 = ({ comparedWorkshops, comparedWorkshopDetails }) => {
    
    return (
        <div className='mb-6'>            
            <CompareWorkshopsRowImage
                title="Most important functions - by groups"
                imgPath="/activity_2/soil_functions_by_group.png"
                property=""
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}                
            />
            <CompareWorkshopsRowImage
                title="Most important functions - overall"
                imgPath="/activity_2/soil_functions_distribution.png"
                property=""
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}                
            />
            <CompareWorkshopsRow
                title="Soil health objectives"                
                property="reports.text_activity_2_objectives"
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}                
            />
            <CompareWorkshopsPublicationAnalysisRow
                title="Analysis summary: soil health objectives"
                diagramKey="objectives"
                comparedWorkshops={comparedWorkshops}
            />
            <div className='columns'>
                <div className='column'>
                    <h2 className='title is-5 has-text-centered'>Current practices for soil health</h2>
                </div>
            </div>
            <CompareWorkshopsRow
                title="Land stewards"
                property="reports.text_activity_2_current_landstewards"
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}
            />
            <CompareWorkshopsRow
                title="Private actors"
                property="reports.text_activity_2_current_private"
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}
            />
            <CompareWorkshopsRow
                title="Public actors"
                property="reports.text_activity_2_current_public"
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}
            />
            <CompareWorkshopsRow
                title="Knowledge actors"
                property="reports.text_activity_2_current_knowledge"
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}
            />
            <CompareWorkshopsRow
                title="Citizens"
                property="reports.text_activity_2_current_citizens"
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}
            />
            <div className='columns'>
                <div className='column'>
                    <h2 className='title is-5 has-text-centered'>Future practices for soil health</h2>
                </div>
            </div>
            <CompareWorkshopsRow
                title="Land stewards"
                property="reports.text_activity_2_future_landstewards"
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}
            />
            <CompareWorkshopsRow
                title="Private actors"
                property="reports.text_activity_2_future_private"
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}
            />
            <CompareWorkshopsRow
                title="Public actors"
                property="reports.text_activity_2_future_public"
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}
            />
            <CompareWorkshopsRow
                title="Knowledge actors"
                property="reports.text_activity_2_future_knowledge"
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}
            />
            <CompareWorkshopsRow
                title="Citizens"
                property="reports.text_activity_2_future_citizens"
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}
            />
        </div>
    );
};

export default CompareWorkshopsActivity2;
